import React from 'react';
import { Github, BookOpen } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 px-6 border-t border-border bg-muted/30">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <div className="flex items-center space-x-2">
            <img 
              src="/agentd-logo.png?v=2" 
              alt="AgentD Logo" 
              className="h-8 w-auto dark:invert"
            />
          </div>

          <div className="flex items-center space-x-8">
            <a 
              href="https://github.com/getagentd/agentd-py" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <Github className="h-4 w-4" />
              <span>GitHub</span>
            </a>
            <a 
              href="https://github.com/getagentd/agentd-py" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <BookOpen className="h-4 w-4" />
              <span>Docs</span>
            </a>
            <a 
              href="https://pypi.org/project/agentd-sdk/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              PyPI
            </a>
          </div>

          <div className="text-sm text-muted-foreground">
            MIT Licensed. Built for the AI agent era.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;